import cropPreviewHtml from './cropPreview.component.html';
import './cropPreview.component.scss';
class CropPreviewController {
    constructor($scope, CropService) {
        'ngInject';

        this.$scope = $scope;
        this.id = this.makeid();
        this.service = CropService;
    }

    makeid() {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < 6) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }

    getCustomImagePreviewStyle() {
        if (!this.service.imageData) {
            return;
        }

        let previewContainerDim = {
            w: document.getElementById('custom_image_preview_container_' + this.id).offsetWidth,
            h: document.getElementById('custom_image_preview_container_' + this.id).offsetHeight
        };

        let cropData = this.service.data;
        let imageData = this.service.imageData;

        const aspectRatioWH = cropData.width / cropData.height;
        const aspectRatioHW = cropData.height / cropData.width;

        let previewWidth = previewContainerDim.w;
        let previewHeight = previewContainerDim.w * aspectRatioHW;

        if (previewHeight > previewContainerDim.h) {
            previewHeight = previewContainerDim.h;
            previewWidth = previewHeight * aspectRatioWH;
        }

        const imageScale = imageData.naturalWidth / cropData.width;

        const backgroundSize = {
            width: previewWidth * imageScale,
            height: previewWidth * imageScale * (1 / imageData.aspectRatio),
        }

        let offsetX = cropData.x / imageData.naturalWidth;
        let offsetY = cropData.y / imageData.naturalHeight;

        offsetX = -offsetX * backgroundSize.width;
        offsetY = -offsetY * backgroundSize.height;

        return {
            'background-image': 'url(' + this.image + ')',
            'width': previewWidth + 'px',
            'height': previewHeight + 'px',
            'background-size': backgroundSize.width + 'px ' + backgroundSize.height + 'px',
            'background-position': offsetX + 'px ' + offsetY + 'px'
        };
    }
}


let cropPreviewComponent = {
    bindings: {
        image: '<',
        height: '@'
    },
    template: cropPreviewHtml,
    controller: CropPreviewController
}

export default cropPreviewComponent;
